export const TREATMENT_PLAN_REQUEST_QUERY_KEY = 'treatment-plan-request';
export const TREATMENT_PLAN_REQUESTS_QUERY_KEY = 'treatment-plan-requests';
export const PATIENTS_QUERY_KEY = 'patients';
export const REGIONS_QUERY_KEY = 'regions';
export const TENANTS_QUERY_KEY = 'tenants';
export const ITEM_QUERY_KEY = 'item';
